import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import back from 'asset/img/back.png';
import { OssOther, ossImageUrl } from 'utils/const.js';
import { getGardenInfo } from 'network';
import { MAX_PET_PHASE, PET_PHASE_RECORDS, normalizeGardenInfoForPetPreview } from '../petPhaseConfig';
import './index.scss';

const LEGACY_RECORD_LIST = [
    { name: '幼年悟空', src_b: OssOther + '/image/pet-oss/pet-01.png', src: OssOther + '/image/pet-oss/pet-01.png', visible: true },
    { name: '顽童悟空', src_b: OssOther + '/image/pet-oss/pet-02-b.jpg', src: OssOther + '/image/pet-oss/pet-02.png', visible: true },
    { name: '少年悟空', src_b: OssOther + '/image/pet-oss/pet-03-b.jpg', src: OssOther + '/image/pet-oss/pet-03.png', visible: true },
    { name: '修行悟空', src_b: OssOther + '/image/pet-oss/pet-04-b.jpg', src: OssOther + '/image/pet-oss/pet-4.png', visible: true },
    { name: '觉醒悟空', src_b: OssOther + '/image/pet-oss/pet-06-b.jpg', src: OssOther + '/image/pet-oss/pet-05.png', visible: true },
    { name: '传奇悟空', src_b: OssOther + '/image/pet-oss/pet-05-b.jpg', src: OssOther + '/image/pet-oss/pet-06.png', visible: true },
    { name: '斗战胜佛', src_b: OssOther + '/image/pet-oss/pet-07-b.jpg', src: OssOther + '/image/pet-oss/pet-07.png', visible: true },
    { name: '混元斗圣', src_b: OssOther + '/image/pet-oss/pet-08-b.jpg', src: OssOther + '/image/pet-oss/pet-08.png', visible: true },
    { name: '涅槃真圣', src_b: OssOther + '/image/pet-oss/pet-09-b.png', src: OssOther + '/image/pet-oss/pet-09.png', visible: true },
    { name: '返老还童', src_b: OssOther + '/image/pet-oss/pet-010-b.png', src: OssOther + '/image/pet-oss/pet-010.png', visible: true },
    { name: '太乙佛尊', src_b: OssOther + '/image/pet-oss/pet-011-b.png', src: OssOther + '/image/pet-oss/pet-011.png', visible: true },
    { name: '齐天大圣', src_b: OssOther + '/image/pet-oss/pet-012-b.png', src: OssOther + '/image/pet-oss/pet-012.png', visible: true },
];

const PetRecord = () => {
    const navigate = useNavigate();
    const [phase, setPhase] = useState(1);

    useEffect(() => {
        getGardenInfo({}).then(res => {
            const gardenInfo = normalizeGardenInfoForPetPreview(res?.data?.garden_info);
            const p = gardenInfo?.PetInfo?.Phase;
            if (p >= 1 && p <= MAX_PET_PHASE) setPhase(p);
        }).catch(() => {});
    }, []);

    const handleBack = () => {
        navigate('/pet');
    };

    return (
        <div className="pet-record-page">
            <img src={back} className="pet-record-back" onClick={handleBack} alt="返回" />
            <div className="pet-record-header">
                <h1 className="pet-record-title">大圣图鉴</h1>
            </div>
            <div className="pet-record-grid">
                {PET_PHASE_RECORDS.map((item, index) => {
                    if (!item.visible) return null;
                    const isUnlocked = phase > index || phase === 0;
                    const imgSrc = isUnlocked ? item.src : item.src_b;
                    return (
                        <div key={index} className="pet-record-card">
                            <div className={`pet-record-card-img pet-record-card-img-phase-${index + 1}`}>
                                <img src={ossImageUrl(imgSrc)} alt={item.name} loading="lazy" />
                                {!isUnlocked && <div className="pet-record-lock" />}
                            </div>
                            <div className="pet-record-card-name">{item.name}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default PetRecord;
